import { render, staticRenderFns } from "./SolutionIot.vue?vue&type=template&id=6963220b"
import script from "./SolutionIot.vue?vue&type=script&lang=js"
export * from "./SolutionIot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports